import AppLayout from '../../layouts/AppLayout/AppLayout';
import MainHeader from '../../Components/MainHeader/MainHeader';
import MainFooter from '../../Components/MainFooter/MainFooter';
import Typography from '@mui/material/Typography';
import CustomContainer from '../../Components/CustomContainer/CustomContainer';
import { FormattedMessage } from 'react-intl';
import classes from './PrivacyPolicy.module.css';

function PrivacyPolicyPage() {
    return (
        <AppLayout>
            <MainHeader variant="cabinet" />
            <main>
                <section
                    className={classes['privacy-policy']}
                    aria-labelledby="privacy-policy-title"
                >
                    <CustomContainer>
                        <Typography
                            variant="h1"
                            color="primary"
                            id="privacy-policy-title"
                            className={classes['privacy-policy__title']}
                        >
                            <FormattedMessage
                                defaultMessage="Политика конфиденциальности"
                                id="PrivacyPolicy_title"
                                description="Политика конфиденциальности"
                            />
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            component="p"
                            className={classes['privacy-policy__subtitle']}
                        >
                            <FormattedMessage
                                defaultMessage="Дата вступления в силу: 01.01.2024"
                                id="PrivacyPolicy_date"
                                description="Политика конфиденциальности"
                            />
                        </Typography>
                        <Typography sx={{ mb: 2, justifySelf: 'start' }}>
                            <FormattedMessage
                                defaultMessage="Мы уважаем вашу конфиденциальность и стремимся защитить ваши личные
                            данные. Настоящая Политика конфиденциальности объясняет, как мы
                            собираем, используем и защищаем информацию о вас в нашем приложении."
                                id="PrivacyPolicy_preamble"
                                description="Политика конфиденциальности"
                            />
                        </Typography>
                        <section
                            aria-labelledby="definitions"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="definitions"
                            >
                                <FormattedMessage
                                    defaultMessage="Определение понятий"
                                    id="PrivacyPolicy_concepts"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Закон"
                                        id="PrivacyPolicy_concepts1"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает Федеральный закон Российской Федерации «О персональных
                                данных» со всеми изменениями и дополнениями, а также иные
                                законодательные акты Российской Федерации."
                                    id="PrivacyPolicy_concepts2"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Приложение"
                                        id="PrivacyPolicy_concepts3"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="это программное обеспечение (со всеми
                                существующими дополнениями и улучшениями), предназначенное для
                                работы на смартфонах, планшетах и персональных компьютерах. Для
                                целей настоящей Политики под приложением подразумевается следующее
                                программное обеспечение: WattAttack."
                                    id="PrivacyPolicy_concepts4"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Пользователь"
                                        id="PrivacyPolicy_concepts5"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает юридическое или физическое лицо,
                                которое загрузило приложение на смартфон, планшет и или компьютер
                                и/или осуществило активацию такого приложения на одном из указанных
                                устройств, а также посетило сайт приложения по адресам на домене
                                wattattack.com."
                                    id="PrivacyPolicy_concepts6"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="«Правообладатель»"
                                        id="PrivacyPolicy_concepts7"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает следующее лицо, которому
                                принадлежат исключительные права владения приложением: ООО
                                «Ваттаттак», юридический адрес: 432048, Ульяновская область, г.
                                Ульяновск, Университетская Набережная ул, д. 13, кв. 68."
                                    id="PrivacyPolicy_concepts8"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Персональные данные"
                                        id="PrivacyPolicy_concepts9"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает совокупность личных данных и/или неперсонифицированной информации о Пользователе, предоставляемую им самим Правообладателю и/или автоматически собираемую Правообладателем и/или третьими лицами."
                                    id="PrivacyPolicy_concepts10"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="«Политика»"
                                        id="PrivacyPolicy_concepts11"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает совокупность личных данных и/или неперсонифицированной информации о Пользователе, предоставляемую им самим Правообладателю и/или автоматически собираемую Правообладателем и/или третьими лицами"
                                    id="PrivacyPolicy_concepts12"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Файлы куки"
                                        id="PrivacyPolicy_concepts13"
                                        description="Политика конфиденциальности"
                                    />
                                </b>{' '}
                                <FormattedMessage
                                    defaultMessage="означает небольшие файлы, отправляемые
                                каким-либо приложениям или сайтом, и размещаемые на смартфонах,
                                планшетах и других устройствах Пользователя, для улучшения работы
                                таких приложений или сайтов, а также качества размещенного в них
                                контента."
                                    id="PrivacyPolicy_concepts14"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>
                        <section
                            aria-labelledby="rights"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="rights"
                            >
                                <FormattedMessage
                                    defaultMessage="Права пользователя по защите персональных данных"
                                    id="PrivacyPolicy_rights"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="В связи с предоставлением Персональных данных Пользователь автоматически получает следующие права:"
                                    id="PrivacyPolicy_rights1"
                                    description="Политика конфиденциальности"
                                />
                                <ul>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="получать данные, касающиеся их обработки (основания и цели такой обработки, применяемые способы обработки, сведения о лицах, которые имеют доступ к ним или которым они могут быть раскрыты на основании Политики или Закона);"
                                            id="PrivacyPolicy_rights2"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="получать данные о месте нахождения и идентификационных данных лиц, совершающих обработку Персональных данных;"
                                            id="PrivacyPolicy_rights3"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="получать данные о сроках хранения Персональных данных;"
                                            id="PrivacyPolicy_rights4"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="получать данные об осуществленной или о предполагаемой трансграничной передаче Персональных данных;"
                                            id="PrivacyPolicy_rights5"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="обжаловать действия или бездействие Правообладателя в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке;"
                                            id="PrivacyPolicy_rights6"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="получать возмещение убытков и/или компенсацию морального вреда в судебном порядке в следствие допущенных Правообладателем и/или третьими лицами нарушений прав Пользователя на охрану и защиту его Персональных данных;"
                                            id="PrivacyPolicy_rights7"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            defaultMessage="реализовывать иные права в области защиты персональных данных, предусмотренные Законом или положениями данной Политики."
                                            id="PrivacyPolicy_rights8"
                                            description="Политика конфиденциальности"
                                        />
                                    </li>
                                </ul>
                            </Typography>
                        </section>
                        <section
                            aria-labelledby="list"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="list"
                            >
                                <FormattedMessage
                                    defaultMessage="Перечень собираемых данных"
                                    id="PrivacyPolicy_list"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Неперсонифицированная информация о пользователях"
                                        id="PrivacyPolicy_list1"
                                        description="Политика конфиденциальности"
                                    />
                                </b>
                                <br />
                                <FormattedMessage
                                    defaultMessage="В связи с использованием приложения Правообладатель может автоматически собирать и обрабатывать следующую неперсонифицированную информацию о Пользователе: информацию о трафике, возможном количестве совершенных кликов, логи и другие данные; информацию о месте нахождении Пользователя (геолокация) включена в функциональность приложения, но данные геолокации не сохраняются приложением и не передаются; информацию об устройстве, с которого выполняется вход, операционная система, платформа, прочая техническая информация (размер экрана, операционная система и подобное)."
                                    id="PrivacyPolicy_list2"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <b>
                                    <FormattedMessage
                                        defaultMessage="Личные данные пользователей"
                                        id="PrivacyPolicy_list3"
                                        description="Политика конфиденциальности"
                                    />
                                </b>
                                <br />
                                <FormattedMessage
                                    defaultMessage="Пользователь также даёт согласие на передачу персональной информации Правообладателю для целей контроля качества оказываемых услуг, а также для обработки запросов и претензий Пользователя, связанных с работой Сервиса и/или приложения. Правообладатель вправе использовать данные, содержащие обезличенную персональную информацию Пользователей, в том числе осуществлять передачу таких данных третьим лицам для создания и обработки статистических данных, улучшения качества оказания услуг и качества Сервиса и др."
                                    id="PrivacyPolicy_list4"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="purposes"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="purposes"
                            >
                                <FormattedMessage
                                    defaultMessage="Цели сбора и обработки персональных данных"
                                    id="PrivacyPolicy_purposes"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Для оперативной и корректной работы приложения, улучшения функционирования работы приложения, улучшения контента приложения, улучшения внутренней архитектуры и функциональности приложения. для идентификации Пользователя. для соблюдения требований Закона. для технической поддержки приложения, выявления проблем в его работе и их устранение. для выполнения иных обязательств Правообладателя, которые возникли перед Пользователем. для любых других целей, при условии получения отдельного согласия от Пользователя."
                                    id="PrivacyPolicy_purposes1"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Обработка Персональных данных осуществляется на основе принципов: законности целей и способов обработки,добросовестности, соответствия целей обработки Персональных данных целям, заранее определенным и заявленным при сборе таких Персональных данных и соответствия объема и характера обрабатываемых Персональных данных заявленным целям их обработки."
                                    id="PrivacyPolicy_purposes2"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="conditions"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="conditions"
                            >
                                <FormattedMessage
                                    defaultMessage="Условия обработки персональных данных"
                                    id="PrivacyPolicy_conditions"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Обработка Персональных данных проводится в случаях получения согласия от Пользователя. Правообладатель обязуется обрабатывать персональную информацию Пользователя, полученную им в рамках оказания Услуг по Подписке, в соответствии с требованиями Федерального закона «О персональных данных» от 27.07.2006 № 152-ФЗ. Обработка персональной информации Пользователя ограничена целями оказания Услуг по Подписке. Правообладатель вправе передать персональную информацию третьим лицам только в случае, если такая передача необходима для оказания Услуг, в том числе при участии или привлечении третьих лиц к выполнению обязанностей перед пользователем. В случае обезличивания Персональных данных, что не позволяет прямо или опосредованно определить Пользователя, последующее использование и раскрытие таких данных третьим лицам допускается и в отношении их более не применяются правила данной Политики. Правообладатель принимает все возможные меры для защиты конфиденциальности полученных Персональных данных, за исключением случаев, когда Пользователь сделал такие данные общедоступными. Обработка Персональных данных осуществляется с использованием средств автоматизации и без использования таких средств автоматизации."
                                    id="PrivacyPolicy_conditions1"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="complaints"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="complaints"
                            >
                                <FormattedMessage
                                    defaultMessage="Направление жалоб и запросов правообладателю"
                                    id="PrivacyPolicy_complaints"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Жалобы, требования и запросы направляются Правообладателю на адрес
                                электронной почты"
                                    id="PrivacyPolicy_complaints1"
                                    description="Политика конфиденциальности"
                                />{' '}
                                <a href="mailto:info@wattattack.com">info@wattattack.com</a>
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="order"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="order"
                            >
                                <FormattedMessage
                                    defaultMessage="Сроки и порядок хранения персональных данных"
                                    id="PrivacyPolicy_order"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Хранение осуществляется самостоятельно Правообладателем. Хранение осуществляется в течение всего срока использования Пользователем данного приложения."
                                    id="PrivacyPolicy_order1"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="protection"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="protection"
                            >
                                <FormattedMessage
                                    defaultMessage="Порядок защиты персональных данных"
                                    id="PrivacyPolicy_protection"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Защита конфиденциальности Персональных данных является первостепенной и важной задачей для Правообладателя. Правообладатель придерживается всех требуемых международных стандартов, правил и рекомендаций по защите Персональных данных."
                                    id="PrivacyPolicy_protection1"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>

                        <section
                            aria-labelledby="conclusion"
                            className={classes['privacy-policy__section']}
                        >
                            <Typography
                                variant="h2"
                                className={classes['privacy-policy__section-title']}
                                id="conclusion"
                            >
                                <FormattedMessage
                                    defaultMessage="Заключение"
                                    id="PrivacyPolicy_conclusion"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                            <Typography className={classes['privacy-policy__text']}>
                                <FormattedMessage
                                    defaultMessage="Используя наше приложение, вы соглашаетесь с условиями этой Политики конфиденциальности. Если вы не согласны с любым из условий, пожалуйста, не используйте наше приложение."
                                    id="PrivacyPolicy_conclusion1"
                                    description="Политика конфиденциальности"
                                />
                            </Typography>
                        </section>
                        <Typography className={classes['privacy-policy__text']}>
                            <b>
                                <FormattedMessage
                                    defaultMessage="Дата последнего обновления: 01.07.2024"
                                    id="PrivacyPolicy_conclusion2"
                                    description="Политика конфиденциальности"
                                />
                            </b>
                            <br />
                            <FormattedMessage
                                defaultMessage="Эта Политика конфиденциальности была создана для обеспечения прозрачности в отношении того, как мы обрабатываем и защищаем ваши данные. Мы стремимся к тому, чтобы ваше взаимодействие с нашим приложением было безопасным и конфиденциальным."
                                id="PrivacyPolicy_conclusion3"
                                description="Политика конфиденциальности"
                            />
                        </Typography>
                    </CustomContainer>
                </section>
            </main>
            <MainFooter />
        </AppLayout>
    );
}

export default PrivacyPolicyPage;
